import React, { SyntheticEvent } from 'react';

import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import { __t, applyTranslations } from 'utils/language';

import './content-performance-viewer.scss';

applyTranslations(require('../../content-performance.i18n.json'));

type Props = {
  view: string,
  onSetView: (event: SyntheticEvent<HTMLElement>) => void
};

const MSG_KEY = 'content_performance';

const ContentPerformanceViewer = ({
  view,
  onSetView
}: Props): JSX.Element => {
  const views = ['details', 'total'];

  const tabItems = views.map(value => ({
    handleClick: onSetView,
    handleClickArg: value,
    isActive: value === view,
    label: __t(`${MSG_KEY}.labels.${value}`)
  }));

  return (
    <div className="content-performance-viewer">
      <TabsUnderlined
        items={tabItems}
        size="small"
      />
    </div>
  );
};

export default ContentPerformanceViewer;
